<nav class="bg-white border-b w-full h-full flex justify-between items-center pr-5 md:pr-10 lg:py-3  lg:px-10">
  <div class="flex items-center gap-3">
    <!-- side menu -->
    <div class="drawer w-auto lg:hidden">
      <input id="menu-sidebar" type="checkbox" class="drawer-toggle hidden" />
      <div class="drawer-content ">
        <label for="menu-sidebar" class=" bg-primary-950 text-white btn-sm w-16 h-16 shadow-none  border-0 flex justify-center items-center text-lg">
          <i class="ri-menu-line"></i>
        </label>
      </div>
      <div class="drawer-side z-10">
        <label for="menu-sidebar" aria-label="close sidebar" class="drawer-overlay"></label>
        <app-sidebar></app-sidebar>
      </div>
    </div>
    <!-- side menu -->
     <div class="flex flex-col items-start">
       <small>Hello, </small>
       <p class="font-semibold">{{ navbarName }}
      </p>
      </div>
  </div>
  <div class="flex items-center gap-2">

    <!-- notifications -->
    <div class="drawer drawer-end w-auto">
      <input id="notification" type="checkbox" class="drawer-toggle hidden" />
      <div class="drawer-content ">
        <label for="notification" class="btn btn-sm w-10 h-10 rounded-full bg-transparent shadow-none  border-0 flex text-lg">
          <i class="ri-notification-3-line"></i>
        </label>
      </div>
      <div class="drawer-side z-10">
        <label for="notification" aria-label="close sidebar" class="drawer-overlay"></label>
        <ul class="menu bg-base-200 text-base-content min-h-full w-80 p-4">
          <li><a>Sidebar Item 1</a></li>
          <li><a>Sidebar Item 2</a></li>
        </ul>
      </div>
    </div>



    <!-- notifications -->
    <!-- <button (click)="toggleDarkMode()" 
    class="btn btn-sm w-10 h-10 rounded-full bg-transparent shadow-none border-0 flex text-lg">
    @if (isDarkMode$ | async) {
      <i class="ri-sun-line"></i>
    } @else {
      <i class="ri-moon-line"></i>
    }
  </button> -->
  
    <!-- <button class="btn btn-circle text-xl"><i class="ri-settings-line"></i></button> -->

    <div class="dropdown dropdown-end relative">
      <div
        tabindex="0"
        role="button"
        class="btn p-0 flex flex-nowrap items-center gap-2 hover:bg-transparent border-0 bg-transparent shadow-none hover:border-0"
      >
        <img [src]="profileUrl" alt="" class="w-10 h-10 rounded-full object-cover" />
        <i class="ri-arrow-down-s-line"></i>
      </div>
      <ul tabindex="0" class="capitalize dropdown-content menu mt-1 bg-base-100 rounded-box z-[9999] w-52 p-2 shadow-2xl border">
        <div class=" capitalize p-3">
            <div class="flex flex-col items-start bg-transparent hover:bg-transparent focus-within:bg-transparent">
                <div class="text-sm font-semibold capitalize">{{ navbarName }}</div>
                <div class="text-xs text-gray-500 lowercase">{{ navbarEmail }}</div>
                <div class="text-xs text-gray-500 capitalize mt-2">role: {{ getRoleLabel(navbarRoleId) }}</div>
            </div>
        </div>
        <hr class="my-2">
<li>
  <a [routerLink]="['/profile/person-details']">
    <i class="ri-user-6-line"></i> Profile
  </a>
</li>        <li><a><i class="ri-settings-line"></i> Settings</a></li>
        <li><a [routerLink]="['/permission']"><i class="ri-key-2-line"></i> Permission</a></li>
        <li><a [routerLink]="['/theme-builder']"   ><i class="ri-palette-line"></i> Theme</a></li>
        <hr class="my-2">
        <li class=""><a class="bg-red-50 text-red-600 rounded-lg hover:bg-red-100" (click)="logout()"><i class="ri-logout-circle-line"></i> Logout</a></li>
      </ul>
    </div>

  </div>
</nav>
